import { useTranslation } from "react-i18next";
import dayjs from "dayjs";

import { getCities } from "../../../utils/functions";
import Input from "../../common/Input";

const Document = ({
  formData,
  invalidFields,
  handleChange,
  handleBlur,

  isItalia,
  nations
}) => {
  const { t } = useTranslation();

  const handleIssuedByChange = (field, value, callback) => {
    handleChange(field, value);
    if (!isItalia) return;
    getCities(value).then(res => callback(res));
  };

  const handleIssuedBySelect = (option) => {
    handleChange("documentIssuedBy", option.comune);
  };

  return (
    <div className="customer__form__data data--document">
      <Input
        type="select"
        name="documentType"
        label={t("customer.form.documentType.label")}
        value={formData.documentType}
        invalid={invalidFields["documentType"]}
        options={[
          { value: "", text: "" },
          { value: "CARTA D'IDENTITA", text: t("customer.documentTypes.idCard") },
          { value: "PASSAPORTO", text: t("customer.documentTypes.passport") }
        ]}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Input
        type="text"
        name="documentNumber"
        label={t("customer.form.documentNumber.label")}
        value={formData.documentNumber}
        invalid={invalidFields["documentNumber"]}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Input
        type={isItalia ? "autocomplete" : "select"}
        name="documentIssuedBy"
        label={t("customer.form.documentIssuedBy.label")}
        helper={isItalia ? t("customer.form.documentIssuedBy.cityHelper") : t("customer.form.documentIssuedBy.nationHelper")}
        value={formData.documentIssuedBy}
        invalid={invalidFields["documentIssuedBy"]}
        options={["", ...nations]}
        onChange={handleIssuedByChange}
        onSelect={handleIssuedBySelect}
        onBlur={handleBlur}
      />
      <Input
        type="date"
        name="documentReleaseDate"
        label={t("customer.form.documentReleaseDate.label")}
        value={formData.documentReleaseDate}
        invalid={invalidFields["documentReleaseDate"]}
        datePickerMin={dayjs().subtract(10, "year").toDate()}
        datePickerMax={dayjs().toDate()}
        onChange={handleChange}
      />
      <Input
        type="date"
        name="documentExpirationDate"
        label={t("customer.form.documentExpirationDate.label")}
        value={formData.documentExpirationDate}
        invalid={invalidFields["documentExpirationDate"]}
        datePickerMin={dayjs().toDate()}
        datePickerMax={dayjs().add(10, "year").toDate()}
        onChange={handleChange}
      />
    </div>
  );
};

export default Document;
